;
// https://github.com/wix-private/wix-answers-server/blob/dbd842a6ba9747c1c4df1d48b71cdbb3e9a244c8/answers/wix-answers-core/src/main/java/com/wixpress/answers/common/exceptions/Errors.java#L124
export var InstagramErrorCode;
(function (InstagramErrorCode) {
    InstagramErrorCode[InstagramErrorCode["CONNECT_OR_RECONNECT_GENERIC_ERROR"] = -220010] = "CONNECT_OR_RECONNECT_GENERIC_ERROR";
    InstagramErrorCode[InstagramErrorCode["ACCOUNT_ALREADY_CONNECTED_TO_OTHER_TENANT"] = -220011] = "ACCOUNT_ALREADY_CONNECTED_TO_OTHER_TENANT";
})(InstagramErrorCode || (InstagramErrorCode = {}));
export var instagramRelativePath = '/instagram';
var getCurrentLocation = function (pathName) { return "" + window.location.origin + (pathName || window.location.pathname); };
export var createInstagramApi = function (baseUrl, http) {
    var instagramApiUrl = baseUrl + instagramRelativePath;
    return {
        goToConnectAccount: function (pathName) {
            var url = getCurrentLocation(pathName);
            var encodedUrl = encodeURIComponent(url);
            var instagramAuthUrl = instagramApiUrl + "/authUrl?redirectUrl=" + encodedUrl;
            window.location.href = instagramAuthUrl;
        },
        reconnectAccount: function (id, pathName) {
            var url = getCurrentLocation(pathName);
            var encodedUrl = encodeURIComponent(url);
            var instagramAuthUrl = instagramApiUrl + "/authUrl/" + id + "?redirectUrl=" + encodedUrl;
            window.location.href = instagramAuthUrl;
        },
        disconnectAccount: function (id) {
            return http.delete(instagramApiUrl + "/accounts/" + id);
        },
        getAccounts: function (validate) {
            return http.get(instagramApiUrl + "/accounts?validate=" + !!validate);
        },
        updateAccountSettings: function (dto) {
            return http.put(instagramApiUrl + "/accounts/" + dto.id, dto);
        },
    };
};
//# sourceMappingURL=index.js.map